import { useCallback, useEffect, useState } from "react";
import { CalendlyExpert } from "../../../utils/api-objects/CalendlyExpert";
import { getMedicaluserByRole } from "../../../utils/apis/medical-user-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { ExpertRole } from "../../../utils/Enums";

export const useGetSpecialists = () => {
    const { auth } = useAuth();
    const idToken = auth.idToken;

    const [specialists, setSpecialists] = useState<CalendlyExpert[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchSpecialists = useCallback(async () => {
        if (!idToken) return;
        setIsLoading(true);
        setError(null);

        try {
            const result: CalendlyExpert[] | null = await getMedicaluserByRole(idToken, ExpertRole.Specialist);
            if (result !== null) {
                setSpecialists(result);
            }
        } catch (err: any) {
            console.error("Failed to fetch specialists:", err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [idToken]);

    useEffect(() => {
        fetchSpecialists();
    }, [fetchSpecialists]);

    return { specialists, isLoading, error, refetch: fetchSpecialists };
}